<template>
  <div class="broker-dashboard">
    <!-- Header -->
    <div class="broker-dashboard__header mb-6">
      <h1 class="broker-dashboard__title">Dashboard de Brokers</h1>
      <p class="broker-dashboard__subtitle">
        Panel de métricas y rendimiento del equipo de ventas
      </p>
    </div>

    <!-- Summary Cards -->
    <!-- <div class="summary-cards-row mb-6">
      <div class="summary-card">
        <div class="summary-card__icon summary-card__icon--blue">
          <v-icon size="28" color="#1a3a5c">mdi-account-multiple</v-icon>
        </div>
        <div class="summary-card__body">
          <span class="summary-card__label">Total Brokers</span>
          <span class="summary-card__value">{{ metrics.total_brokers }}</span>
          <span class="summary-card__sub"
            >{{ metrics.brokers_with_active_leads }} con leads activos</span
          >
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__icon summary-card__icon--teal">
          <v-icon size="28" color="#0e7c7b">mdi-trending-up</v-icon>
        </div>
        <div class="summary-card__body">
          <span class="summary-card__label">Total Leads</span>
          <span class="summary-card__value">{{
            metrics.total_assigned_leads
          }}</span>
          <span class="summary-card__sub">Leads asignados</span>
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__icon summary-card__icon--navy">
          <v-icon size="28" color="#1a3a5c">mdi-bullseye-arrow</v-icon>
        </div>
        <div class="summary-card__body">
          <span class="summary-card__label">Promedio de Cierre</span>
          <span class="summary-card__value"
            >{{ metrics.avg_closing_pct }}%</span
          >
          <span class="summary-card__sub">Tasa de conversión</span>
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__icon summary-card__icon--red">
          <v-icon size="28" color="#c0392b">mdi-pulse</v-icon>
        </div>
        <div class="summary-card__body">
          <span class="summary-card__label">Promedio Vencidos</span>
          <span class="summary-card__value"
            >{{ metrics.avg_overdue_pct }}%</span
          >
          <span class="summary-card__sub">Leads vencidos</span>
        </div>
      </div>

      <div class="summary-card">
        <div class="summary-card__icon summary-card__icon--teal">
          <v-icon size="28" color="#0e7c7b">mdi-flask-outline</v-icon>
        </div>
        <div class="summary-card__body">
          <span class="summary-card__label">Muestra</span>
          <span class="summary-card__value">{{ metrics.sampleSize }}</span>
          <span class="summary-card__sub">Leads tomados por broker</span>
        </div>
      </div>
    </div> -->

    <!-- Filters -->
    <!-- <div class="broker-dashboard__filters mb-4">
      <v-text-field
        v-model="search"
        placeholder="Buscar broker..."
        prepend-inner-icon="mdi-magnify"
        outlined
        dense
        hide-details
        class="broker-search"
        clearable
      />
      <div class="filter-controls">
        <v-select
          v-model="filterActive"
          :items="filterOptions"
          item-text="label"
          item-value="value"
          outlined
          dense
          hide-details
          class="filter-select"
          prepend-inner-icon="mdi-tune"
        />
        <v-select
          v-model="sortBy"
          :items="sortOptions"
          item-text="label"
          item-value="value"
          outlined
          dense
          hide-details
          class="sort-select"
        />
      </div>
    </div> -->

    <!-- Results count -->
    <p class="broker-dashboard__count mb-4">
      Mostrando {{ filteredBrokers.length }} de
      {{ metrics.total_brokers }} brokers
    </p>

    <!-- Loading -->
    <v-row v-if="loading">
      <v-col v-for="n in 8" :key="n" cols="12" sm="6" md="3">
        <v-skeleton-loader type="card" height="320" />
      </v-col>
    </v-row>

    <!-- Error -->
    <v-alert v-else-if="error" type="error" text>
      {{ error }}
    </v-alert>

    <!-- Broker Cards Grid -->
    <div v-else class="brokers-grid">
      <broker-card-performance
        v-for="broker in filteredBrokers"
        :key="broker.broker_id"
        :broker="broker"
      />
    </div>
  </div>
</template>

<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { fetchBrokerMetricsCards } from "@/api/broker-metrics-api";

export default {
  name: "BrokerDashboard",

  components: {
    BrokerCardPerformance: () =>
      import("@/components/brokers-dashboard/BrokerCardPerformance.vue")
  },

  data() {
    return {
      loading: false,
      error: null,
      brokers: [],
      metrics: {
        total_brokers: 0,
        sampleSize: 0,
        brokers_with_active_leads: 0,
        total_assigned_leads: 0,
        avg_closing_pct: 0,
        avg_overdue_pct: 0
      },
      search: "",
      filterActive: "all",
      sortBy: "closing_pct",
      filterOptions: [
        { label: "Todos", value: "all" },
        { label: "Brokers activos", value: "status_active" },
        { label: "Con leads activos", value: "active" },
        { label: "Sin leads", value: "inactive" }
      ],
      sortOptions: [
        { label: "Nombre", value: "name" },
        { label: "Total Leads", value: "total_leads" },
        { label: "Cierre %", value: "closing_pct" },
        { label: "Vencidos %", value: "overdue_pct" },
        { label: "Comentarios", value: "total_comments" }
      ]
    };
  },

  computed: {
    filteredBrokers() {
      let result = [...this.brokers];

      if (this.search && this.search.trim()) {
        const term = this.search.trim().toLowerCase();
        result = result.filter(b => b.name.toLowerCase().includes(term));
      }

      if (this.filterActive === "status_active") {
        result = result.filter(b => b.status === 1);
      } else if (this.filterActive === "active") {
        result = result.filter(b => b.total_leads > 0);
      } else if (this.filterActive === "inactive") {
        result = result.filter(b => b.total_leads === 0);
      }

      result.sort((a, b) => {
        if (this.sortBy === "name") {
          return a.name.localeCompare(b.name);
        }
        if (this.sortBy === "closing_pct") {
          return (b.closing?.pct || 0) - (a.closing?.pct || 0);
        }
        if (this.sortBy === "overdue_pct") {
          return (b.overdue?.pct || 0) - (a.overdue?.pct || 0);
        }
        return (b[this.sortBy] || 0) - (a[this.sortBy] || 0);
      });

      return result;
    }
  },

  created() {
    this.$emit("update:layout", DefaultLayout);
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loading = true;
      this.error = null;
      try {
        const res = await fetchBrokerMetricsCards();
        const payload = res.data;
        this.metrics = payload.metrics || this.metrics;
        this.brokers = payload.data || [];
      } catch {
        this.error = "Error al cargar los datos del dashboard.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.broker-dashboard {
  padding: 24px;
  background-color: #f0f2f5;
  min-height: 100vh;
}

/* Header */
.broker-dashboard__title {
  font-size: 28px;
  font-weight: 700;
  color: #0d1b2a;
  margin: 0;
}

.broker-dashboard__subtitle {
  font-size: 14px;
  color: #607d8b;
  margin: 4px 0 0;
}

/* Summary Cards */
.summary-cards-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.summary-cards-row .summary-card {
  flex: 1 1 0;
  min-width: 160px;
}

.summary-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.summary-card__icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.summary-card__icon--blue {
  background-color: #e8eef5;
}
.summary-card__icon--teal {
  background-color: #e0f5f5;
}
.summary-card__icon--navy {
  background-color: #e8eef5;
}
.summary-card__icon--red {
  background-color: #fdecea;
}

.summary-card__body {
  display: flex;
  flex-direction: column;
}

.summary-card__label {
  font-size: 12px;
  color: #607d8b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.summary-card__value {
  font-size: 32px;
  font-weight: 700;
  color: #0d1b2a;
  line-height: 1.1;
}

.summary-card__sub {
  font-size: 12px;
  color: #90a4ae;
  margin-top: 2px;
}

/* Filters */
.broker-dashboard__filters {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.broker-search {
  flex: 1;
  min-width: 200px;
  max-width: 320px;
  background: #fff;
  border-radius: 8px;
}

.filter-controls {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.filter-select,
.sort-select {
  width: 160px;
  background: #fff;
}

/* Count text */
.broker-dashboard__count {
  font-size: 13px;
  color: #607d8b;
}

/* Brokers grid */
.brokers-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 10px;
}
</style>
